import axios from "../axios"
import model from "../../model"

export const readLocation = async (id) => {
    let res = await axios.get(`/locations/${id}`)
    return model.fromLocationDTO(res.data)
}

export const updateLocation = async (id, updateLocation) => {
    let locationDTO = model.toLocationDTO(updateLocation)
    return await axios.put(`/locations/${id}`, locationDTO)
}

export const deleteLocation = async (id) => {
    return await axios.delete(`/locations/${id}`)
}
